import $ from 'jquery';
import product from '@wc-stripe/product';
import {toCents} from '@wc-stripe/utils';

$(() => {
    $('form.cart').on('updated_addons', (e) => {
        const $form = $(e.currentTarget);
        // Defer until after all found_variation handlers have run. The addon plugin
        // triggers updated_addons inside its own found_variation handler, which may
        // fire before Product.js updates its price. setTimeout(fn, 0) guarantees
        // we read the correct price from product.getPrice() after all synchronous
        // found_variation handlers have completed.
        setTimeout(() => {
            const $totals = $form.find('#product-addons-total');
            const priceData = $totals.data('price_data');
            if (priceData && Array.isArray(priceData)) {
                // item.cost already accounts for quantity on quantity-based addons,
                // so we build the full total rather than a per-unit value.
                let total = product.getPrice() * product.getQuantity();
                for (const item of priceData) {
                    total += item.cost;
                }
                const update = {total};
                const lineItem = product.getLineItem();
                if (lineItem) {
                    update.lineItems = product.getLineItems().map(item =>
                        item.id === lineItem.id
                            ? {...item, amount: total, amountCents: toCents(total)}
                            : item
                    );
                }
                product.update(update);
            }
        }, 0);
    });
});